import type { FirestoreCustomPackageDocument } from '@/shared/types/custom-package.types'

import { useFirestoreDocument } from './useFirestoreDocument'

interface UseCustomPackageResult {
  customPackage: FirestoreCustomPackageDocument | null
  loading: boolean
  error: Error | null
}

/**
 * Hook to fetch a single custom package from Firestore
 * @param buildingUuid - The UUID of the building
 * @param customPackageId - The ID of the custom package
 * @returns Custom package data, loading state, and error
 */
export function useCustomPackage(
  buildingUuid: string | undefined,
  customPackageId: string | undefined
): UseCustomPackageResult {
  const path =
    buildingUuid && customPackageId
      ? `/assessments/${buildingUuid}/custom_packages/${customPackageId}`
      : ''

  const { data, loading, error } = useFirestoreDocument<FirestoreCustomPackageDocument>(path)

  return {
    customPackage: data,
    loading,
    error,
  }
}
